<template>
  <div class="settled-bets-container">
    <div class="settled-bets-controls">
      <div class="settled-bets-controls-title">
        <span>{{$t(`trader.settledMarkets.filters`)}}</span>
      </div>
      <div class="settled-bets-controls-selections">
        <div class="settled-bets-controls-selection">
          <div class="date-pickers">
            <div class="date-picker"
                 v-click-outside="closeDatePickerStart">
              <div class="date-picker-label" @click="closeDatePickerStart">
                <span>{{$t(`bets.settledBets.from`)}}</span>
              </div>
              <div class="date-picker-container" @click="toggleDatePickerStart">
                <v-text-field
                  v-model="dateStartFormatted"
                  append-icon="krypt-calendar"
                  readonly
                  hide-details
                ></v-text-field>
              </div>
              <v-date-picker
                v-model="dateStart"
                no-title
                @input="getSettledMarkets"
                color="var(--primary)"
                class="date-picker-input"
                :locale="SelectedLanguage"
                v-bind:class="{'date-picker-input--open':openDatepickerStart}"
                prev-icon="krypt-arrow-pointer-left"
                next-icon="krypt-arrow-pointer-right"
                :min="minDateRange"
                :max="dateEnd"
              ></v-date-picker>
            </div>
            <div class="date-picker"
                 v-click-outside="closeDatePickerEnd">
              <div class="date-picker-label" @click="closeDatePickerEnd">
                <span>{{$t(`bets.settledBets.to`)}}</span>
              </div>
              <div class="date-picker-container" @click="toggleDatePickerEnd">
                <v-text-field
                  v-model="dateEndFormatted"
                  append-icon="krypt-calendar"
                  readonly
                  hide-details
                ></v-text-field>
              </div>
              <v-date-picker
                v-model="dateEnd"
                no-title
                @input="getSettledMarkets"
                color="var(--primary)"
                :locale="SelectedLanguage"
                class="date-picker-input date-picker-input--end"
                v-bind:class="{'date-picker-input--open':openDatepickerEnd}"
                prev-icon="krypt-arrow-pointer-left"
                next-icon="krypt-arrow-pointer-right"
                :min="dateStart"
                :max="maxDateRange"
              ></v-date-picker>
            </div>
          </div>
        </div>
        <div class="search-container">
          <div class="search-label">
            <span>{{$t(`trader.searchLabel`)}}</span>
          </div>
          <div class="search-wrapper">
            <input class="search-input" type="text" v-model="searchFilter"
                   :placeholder="this.$t(`trader.searchPlaceholder`)">
            <div class="search-icon">
              <v-icon>krypt-search</v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="settled-bets" v-if="settledMarketsGroupedByEventFiltered.length > 0 && !settledMarketsLoadingState" >
      <settledMarketCard result="won" v-for="(market,index) in settledMarketsGroupedByEventFiltered"
                         v-bind:key="index" :market="market"></settledMarketCard>


  </div>
    <div class="empty-settled-bets" v-show="settledMarketsGroupedByEventFiltered.length === 0 && !settledMarketsLoadingState">
      <div class="empty-settled-bets-image">
        <v-icon>krypt-betslip</v-icon>
      </div>
      <div class="empty-settled-bets-text">
        <span>{{$t(`trader.settledMarkets.noMarketsFound`)}}</span>
      </div>
    </div>
    <div class="loading-settled-bets" v-show="settledMarketsLoadingState">
      <div class="loading-settled-bets-image">
        <v-icon>krypt-loader</v-icon>
      </div>
      <div class="loading-settled-bets-text" >
        <span>{{$t('loading')}}</span>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import settledMarketCard from '@/components/other/settledMarketCard';

export default {
  name: 'SettledMarkets',
  components: { settledMarketCard },
  data: function () {
    return {
      shouldShowDropdown: false,
      dateStart: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toIsoStringLocale()
        .substr(0, 10),
      dateEnd: new Date().toIsoStringLocale()
        .substr(0, 10),
      openDatepickerStart: false,
      openDatepickerEnd: false,
      activePanels: [],
      customDateRangeValue: false,
      presetDateRangeValue: true,
      searchFilter: ''
    };
  },
  computed: {
    SelectedLanguage: function () {
      return window.SelectedLanguage;
    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    dateEndFormatted: function () {
      return new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone

        }
      ).format(new Date(this.dateEnd))
    },
    dateStartFormatted: function () {
      return new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      ).format(new Date(this.dateStart))
    },
    minDateRange: function () {
      let date = new Date();
      date.setDate(date.getDate() - 89);
      return date.toIsoStringLocale()
        ;
    },
    maxDateRange: function () {
      let date = new Date();
      return date.toIsoStringLocale();
    },
    settledMarkets: function () {
      return this.$store.state.trader.settledMarkets.settledMarketsList;
    },
    settledMarketsLoadingState: function () {
      return this.$store.state.trader.settledMarkets.isLoading;
    },
    settledMarketsGroupedByEvent: function () {
      let groupedMarkets = {};

      this.settledMarkets.forEach(function (market) {
        if (!groupedMarkets.hasOwnProperty(market.eventId)) {
          groupedMarkets[market.eventId] = {
            awayTeam: market.awayTeam,
            pnl: market.pnl,
            commission: market.commission,
            currency: market.currency,
            eventId: market.eventId,
            eventStart: market.eventStart,
            eventType: market.eventType,
            eventEnd: market.eventEnd,
            tournamentId: market.tournamentId,
            tournamentName: market.tournamentName,
            sportIdentifier: market.sportIdentifier,
            sportId: market.sportId,
            homeTeam: market.homeTeam,
            markets: [market.marketName],
            timeStamp: market.timeStamp
          };
        } else {
          groupedMarkets[market.eventId].pnl += market.pnl;
          groupedMarkets[market.eventId].commission += market.commission;
          groupedMarkets[market.eventId].markets.push(market.marketName);
        }

      });
      return Object.values(groupedMarkets).sort(function (a, b) {
        let aDate = new Date(a.eventType ==='Match'?a.eventStart : a.eventEnd).setSeconds(0);
        let bDate = new Date(b.eventType ==='Match'?b.eventStart :b.eventEnd).setSeconds(0);
        let aEventName = (a.awayTeam ? a.homeTeam + a.awayTeam : a.eventName);
        let bEventName = (b.awayTeam ? b.homeTeam + b.awayTeam : b.eventName);
        if (aDate !== bDate) {
          return bDate - aDate;
        } else {
          return ('' + aEventName).localeCompare(bEventName);
        };
      })
        ;
    },
    settledMarketsGroupedByEventFiltered: function () {
      return this.settledMarketsGroupedByEvent.filter(function (marketGroup) {
        return (
          (marketGroup.awayTeam && marketGroup.awayTeam?.toLowerCase()
            .includes(this.searchFilter.toLowerCase())) ||
          (marketGroup.homeTeam && marketGroup.homeTeam?.toLowerCase()
            .includes(this.searchFilter?.toLowerCase())) ||
          (marketGroup.homeTeam && marketGroup.tournamentName?.toLowerCase()
            .includes(this.searchFilter?.toLowerCase())) ||
          (marketGroup.sportIdentifier && this.$t(`sports.${marketGroup.sportIdentifier}`)
            ?.toLowerCase()
            .includes(this.searchFilter?.toLowerCase())) ||
          (marketGroup.eventName && marketGroup.eventName?.toLowerCase()
            .includes(this.searchFilter?.toLowerCase())) ||
          marketGroup.marketName?.toLowerCase().includes(this.searchFilter)
        )
          ;
      }.bind(this)).slice(0,50);
    }
  },
  methods: {

    showPanel: function (e) {
      e.stopPropagation();
    },
    getFormattedDate: function (date) {
      return new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          // hour12:false,
          hourCycle: 'h23',
          minute: 'numeric'
        }
      ).format(new Date(new Date(date).toLocaleString('en', {
        timeZone: Intl.DateTimeFormat()
          .resolvedOptions().timeZone
      })));
    },
    setFromDate:function(){
      this.$store.commit('setSettledMarketsFromDate',new Date(new Date(this.dateStart).setHours(0, 0, 0, 0)).toISOString());
    },
    setToDate:function(){
      this.$store.commit('setSettledMarketsToDate',new Date(new Date(this.dateEnd).setHours(23, 59, 59, 999)).toISOString());
    },
    getSettledMarkets: function () {
      this.openDatepickerStart = false;
      this.openDatepickerEnd = false;
      this.$store.state.trader.settledMarkets.isLoading = true;
      this.setFromDate();
      this.setToDate();
      this.$store.dispatch('getSettledMarkets', {
        from: new Date(new Date(this.dateStart).setHours(0, 0, 0, 0)).toISOString(),
        to: new Date(new Date(this.dateEnd).setHours(23, 59, 59, 999)).toISOString()
      });
    },
    showDropdown: function () {
      this.shouldShowDropdown = !this.shouldShowDropdown;
    },
    toggleDatePickerStart: function () {
      this.openDatepickerStart = !this.openDatepickerStart;
    },
    closeDatePickerStart: function () {
      this.openDatepickerStart = false;
    },
    toggleDatePickerEnd: function () {
      this.openDatepickerEnd = !this.openDatepickerEnd;
    },
    closeDatePickerEnd: function () {
      this.openDatepickerEnd = false;
    },
    customDateRange: function () {
      this.customDateRangeValue = true;
      this.presetDateRangeValue = false;
    },
    presetDateRange: function () {
      this.customDateRangeValue = false;
      this.presetDateRangeValue = true;
    }
  },
  mounted: function () {
    this.getSettledMarkets();
  }
};
</script>

<style scoped>
  .settled-bet-panel-status-bar--won {
    color: var(--aquaman);
  }

  .settled-bet-panel-status-bar--lost {
    color: var(--cyborg);
  }

  .settled-bet-panel-status-bar--even {
    color: var(--grey-600);
  }

  .settled-bets-container {
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  #bets-container {
    overscroll-behavior: contain;
  }

  .settled-bets-controls {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 8px 0;
    border-bottom: 1px solid var(--grey-200);
  }

  .settled-bets-controls-title {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 8px;
  }

  .settled-bets-controls-title > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #5C5F61;
  }

  .settled-bets-dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 8px;
    flex-direction: column;
    width: 100%;
  }

  .settled-bets-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    background-color: var(--grey-100);
  }

  .settled-bets-dropdown-text {
    display: flex;
    padding: 8px;
    user-select: none;
    overflow: hidden;
  }

  .settled-bets-dropdown-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-controls-selections {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .settled-bets-controls-selection {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .search-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-top: 8px;
    padding-right: 8px;
    padding-left: 8px;
  }

  .search-label {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin-bottom: 4px;
  }

  .search-label > span {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: var(--grey-500);
  }

  .search-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-left: 8px;
    padding-right: 4px;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
  }

  .search-wrapper:hover {
    border: 1px solid var(--grey-400);
  }

  .search-wrapper:focus-within {
    border: 1px solid var(--primary);
  }

  .search-input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px 0;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-800);
    caret-color: var(--primary);
    height: 100%;
    max-height: 32px;
  }

  .search-input::placeholder {
    color: var(--grey-400);
  }

  .search-input:-ms-input-placeholder {
    color: var(--grey-400);
  }

  .search-input::-ms-input-placeholder {
    color: var(--grey-400);
  }

  .search-input:focus {
    outline: none;
  }

  .search-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
  }

  .search-icon > .v-icon {
    color: var(--grey-500);
  }

  .selection-radio-btn {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0 8px;
  }

  .selection-radio-btn > span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    margin: 8px 8px 4px 0px;
    color: var(--grey-500);
  }

  .settled-bets-dropdown-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 32px);
  }

  .settled-bets-dropdown-dropdown-arrow, .settled-bets-dropdown-dropdown-arrow > i {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .settled-bets-dropdown-dropdown-arrow {
    margin-right: 4px;
    margin-left: 8px;
  }

  .settled-bets-dropdown-dropdown-arrow > i {
    font-size: 16px;
    color: var(--grey-900);
  }

  .settled-bets-dropdown-dropdown-arrow-open > i {
    transform: rotateZ(-180deg);
  }

  .settled-bets-dropdown-anchor {
    position: relative;
    width: 100%;
  }

  .settled-bets-dropdown-absolute {
    position: absolute;
    width: 100%;
    z-index: 10;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
    top: 0px;
    transition: all 0.3s ease-in-out;
    background: white;
    border-radius: 4px;
    padding: 0;
  }

  .settled-bets-dropdown-absolute-open {
    top: 4px;
    overflow: hidden;
    padding: 4px 0;
  }

  .settled-bets-dropdown-contents::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
    /* disabling to make it look like on Firefox
    border-radius: 4px;
    margin-bottom: 4px; */
  }

  .settled-bets-dropdown-contents::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .settled-bets-dropdown-contents::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .settled-bets-dropdown-contents {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 0;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    border-radius: 4px;
    /*border: white 1px solid;*/
    background: white;
    scrollbar-width: thin;
  }


  .settled-bets-dropdown-contents-open {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    max-height: 200px;
  }

  .settled-bets-dropdown-contents:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .settled-bets-dropdown-contents:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .settled-bets-dropdown-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transition: background-color 0.25s ease-in-out;
  }

  .settled-bets-dropdown-item:hover {
    background: var(--grey-200);
    cursor: pointer;
  }

  .settled-bets-dropdown-item-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .settled-bets-dropdown-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin: 0 4px;
  }

  .settled-bets-dropdown-item-text {
    display: flex;
    padding: 8px;
    user-select: none;
  }

  .settled-bets-dropdown-item-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
  }

  .date-pickers {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 4px;
    width: 100%;
  }

  /*  .date-picker{
      position: relative;
    }*/

  .date-picker-input {
    display: inline-table;
    position: absolute;
    transform: scale(0);
    transform-origin: 0% 0%;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
    /* applied same shadow with dropdown lists for consistency
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12); */
    margin-top: 4px;
    z-index: 11;
  }

  .date-picker-input--end {
    transform-origin: 100% 0%;
    right: 8px;
  }

  .date-picker-input--open {
    transform: scale(1);
  }

  .date-picker {
    padding: 0 4px;
    overflow: hidden;
    width: 100%;
  }

  .date-picker-label {
    display: flex;
    width: 100%;
    overflow: hidden;
    padding-top: 8px;
    padding-bottom: 4px;
  }

  .date-picker-label > span {
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-500);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .date-picker-container {
    cursor: pointer;
  }

  .date-picker-container * {
    pointer-events: none;
  }

  .settled-bets {
    display: flex;
    flex-direction: column;
    padding: 8px;
  }

  .settled-bets-expansion-header-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0px !important;
  }

  .settled-bets-expansion-header-inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 8px;
    transition: all 0.2s ease-in-out;
    cursor: auto;
  }

  .settled-bets-expansion-header-inner span {
    cursor: text !important;
  }

  .settled-bets-expansion-header-inner * {
    user-select: text;
  }

  .settled-bets-expansion-header {
    display: flex;
    padding: 8px;
    min-height: unset;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    width: 100%;
  }

  .settled-bets-expansion-header > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
  }

  .settled-bets-expansion-header-wrapper > >>> .v-expansion-panel-header__icon {
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }

  .settled-bets-expansion-header > >>> .v-expansion-panel-header__icon > .v-icon {
    color: white !important;
    font-size: 24px;
  }

  .settled-bets-expansion-header--won {
    background-color: var(--aquaman);
  }

  .settled-bets-expansion-header--lost {
    background-color: var(--cyborg);
  }

  .settled-bets-expansion-header--even {
    background-color: var(--grey-400);
  }

  .settled-bets-date-wrapper {
    display: flex;
    padding-bottom: 4px;
  }

  .settled-bets-date-container {
    display: flex;
    margin-right: auto;
  }

  .settled-bets-date-title {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-500);
    margin-right: 6px
  }

  .settled-bets-date {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-900);
  }

  .settled-bets-result-wrapper {
    display: flex;
    padding-bottom: 8px;
  }

  .settled-bets-result-container {
    display: flex;
  }

  .settled-bets-result-title {
    margin-right: 8px;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    color: var(--grey-500);
  }

  .settled-bets-result-team {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    color: var(--grey-900);
    margin-right: auto;
  }

  .settled-bets-result {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: right;
    color: var(--grey-900);
  }

  .settled-bets-winnings-wrapper {
    display: flex;
  }

  .settled-bets-winnings-cell, .settled-bets-commission-cell {
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    min-width: 100px;
  }

  .settled-bets-winnings-cell > span {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    /*color: var(--aquaman);*/
    padding-bottom: 1px;
    text-transform: uppercase;
    max-width: 100px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-commission-cell > span {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    color: var(--grey-600);
    padding-bottom: 1px;
    text-transform: uppercase;
    max-width: 100px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .settled-bets-winnings-value, .settled-bets-commission-value {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: var(--grey-100);
    text-align: center;
    border: 1px solid var(--grey-100);
  }

  .settled-bets-commission-value > span, .settled-bets-winnings-value > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: var(--grey-900);
    padding: 5px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .custom-radio-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    background: var(--grey-100);
    border: 1px solid var(--grey-300);
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  .custom-radio-btn--selected {
    background: var(--primary);
    border-color: var(--superman);
  }

  .custom-radio-btn-inner {
    height: 8px;
    width: 8px;
    background: white;
    opacity: 0.4;
    border-radius: 50%;
  }


  .empty-settled-bets {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  }

  .empty-settled-bets-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
  }

  .empty-settled-bets-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
    font-size: 122px;
    color: var(--grey-300);
  }

  .empty-settled-bets-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .empty-settled-bets-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
  }

  .settled-bet-card:first-of-type {
    margin-top: 0px !important;
  }

  .number-of-bets-wrapper {
    display: flex;
    overflow: hidden;
    max-width: calc(100% / 3);
    flex-wrap: nowrap;
    flex-shrink: 0;
    margin-left: 8px;
  }

  .number-of-bets-title {
    display: flex;
    overflow: hidden;
  }

  .number-of-bets {
    padding-right: 4px;
  }

  .number-of-bets-title > span {
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-500);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .number-of-bets > span {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: var(--grey-900);
  }

  /*Vuetify*/

  >>> .v-expansion-panel::before {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19) !important;
  }

  >>> .v-expansion-panel > .settled-bets-expansion-header {
    border-radius: 6px;
  }

  >>> .v-expansion-panel {
    transition: border-radius 1s ease-in-out;
    border-radius: 6px;
    margin-bottom: 8px;
    margin-top: 0px !important;
  }

  >>> .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
  }

  >>> .v-expansion-panel--active > .settled-bets-expansion-header {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  >>> .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
    opacity: 0 !important;
  }

  >>> .v-expansion-panel-content__wrap {
    padding: 0px 4px 8px 4px;
  }

  >>> .v-input__slot {
    margin-bottom: 0px !important;
    padding-right: 4px;
    padding-left: 8px;
    border-radius: 4px !important;
    border: solid 1px var(--grey-300);
  }

  .date-picker-container:hover >>> .v-input__slot {
    border: solid 1px var(--grey-400) !important;
  }

  >>> .v-input__slot:before {
    border: none !important;
  }

  >>> .v-text-field__slot > input {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800) !important;
  }

  >>> .v-input__icon > .v-icon {
    color: var(--grey-500);
  }

  .v-text-field {
    padding: 0px !important;
    margin: 0px !important;
  }

  .v-text-field > >>> .v-input__control > .v-input__slot:after {
    border: none !important;
  }

  .v-text-field >>> .v-input__prepend-inner, .v-text-field >>> .v-input__append-inner {
    margin: 4px 0;
  }

  .loading-settled-bets{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
  }

  .loading-settled-bets-image{
    height: 16px;
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loading-settled-bets-image > .v-icon{
    font-size: 16px;
    color: var(--grey-400);
    animation: spin 1s infinite linear;
  }

  .loading-settled-bets-image > .v-icon:before{
    color: var(--grey-400);
  }

  .loading-settled-bets-text{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loading-settled-bets-text > span{
    font-size: 14px;
    line-height: 16px;
    color: var(--grey-400);
    padding-left: 8px;
  }

  @keyframes spin {
    0% {
      transform: rotateZ(0)
    }
    100% {
      transform: rotateZ(360deg)
    }
  }

</style>
